import { ApplicationEntity } from "@/model/entity/application-entity"
import { Office } from "@/model/entity/office/office"
import { RoleEnum } from "@/model/enum/role-enum"
import {Type} from "class-transformer"

export class Employee extends ApplicationEntity {
  username: string
  password: string
  role: RoleEnum
  @Type(() => Office)
  office?: Office
  email?: string

  constructor(
    id?: number,
    username: string = "",
    password: string = "",
    role: RoleEnum = RoleEnum.CUSTOMER,
    office?: Office
  ) {
    super(id)
    this.username = username
    this.password = password
    this.role = role
    this.office = office
  }
}
